import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
interface LanguageSwitcherProps {
  isScrolled?: boolean;
  mobile?: boolean;
}
export function LanguageSwitcher({
  isScrolled = false,
  mobile = false
}: LanguageSwitcherProps) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const activeTextClass = mobile ? 'text-sage-700 font-medium' : isScrolled ? 'text-sage-700 font-medium' : 'text-sage-100 font-medium [text-shadow:0_1px_2px_rgba(0,0,0,0.5)]';
  const inactiveTextClass = mobile ? 'text-charcoal-50 hover:text-charcoal' : isScrolled ? 'text-charcoal/60 hover:text-charcoal' : 'text-white/70 hover:text-white [text-shadow:0_1px_2px_rgba(0,0,0,0.5)]';
  return <div className={`flex items-center gap-2 ${mobile ? 'text-base' : 'text-xs tracking-widest'}`} data-id="element-360" data-mp="e8oantd1a4ra">
      <button onClick={() => setLanguage('en')} aria-pressed={language === 'en'} className={`relative px-1 transition-colors ${language === 'en' ? activeTextClass : inactiveTextClass}`} data-id="element-361" data-mp="i6cdrjovr3u9">
        EN
        {language === 'en' && <motion.span layoutId={`lang-indicator-${mobile ? 'mobile' : 'desktop'}`} className={`absolute -bottom-1 left-0 right-0 h-[1.5px] ${mobile || isScrolled ? 'bg-sage-700' : 'bg-sage-100'}`} initial={false} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30
      }} data-id="element-362" data-mp="28jlotur6ad15" />}
      </button>
      <span className={`w-px h-3 ${mobile ? 'bg-charcoal-50/30' : isScrolled ? 'bg-charcoal/20' : 'bg-white/30'}`} data-id="element-363" data-mp="2rcg2mld27z3s" />
      <button onClick={() => setLanguage('sl')} aria-pressed={language === 'sl'} className={`relative px-1 transition-colors ${language === 'sl' ? activeTextClass : inactiveTextClass}`} data-id="element-364" data-mp="2hlv0wp23aegn">
        SL
        {language === 'sl' && <motion.span layoutId={`lang-indicator-${mobile ? 'mobile' : 'desktop'}`} className={`absolute -bottom-1 left-0 right-0 h-[1.5px] ${mobile || isScrolled ? 'bg-sage-700' : 'bg-sage-100'}`} initial={false} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30
      }} data-id="element-365" data-mp="3a97mavwikg8d" />}
      </button>
    </div>;
}